// extracted by mini-css-extract-plugin
export default {"container":"WalletSetupIndicator_container__Two0O","setupStatusText":"WalletSetupIndicator_setupStatusText__BjPDv","nextButton":"WalletSetupIndicator_nextButton__MDWlJ"};